
export const MOBILE_MAXIMUM_RESOLUTION = 767.98;
export const TABLET_MINIMUM_RESOLUTION = 768;
export const TABLET_MAXIMUM_RESOLUTION = 991.98;
export const DESKTOP_MINIMUM_RESOLUTION = 992;
export const PAGE_TITLE_POSTFIX = " - Fellowship and Awards system - The Ohio State University"